import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import { SingleOption } from '@/components/blocks/pickup-point/pickup-point';
import Link from '@/components/utilities/link/link';
import useCurrencyFormatter from '@/libraries/formatters/use-currency-formatter';
import styles from './pickup-point-select-single.module.scss';

export interface PickupPointSelectSingleProps {
  /** The class name to apply */
  className?: string;
  /** The headline text */
  headline: string;
  /** Whether the option is disabled */
  isSelected: boolean;
  /** An event that is triggered on click */
  onClick?: () => void;
  /** The single option to choose */
  singleOption: SingleOption;
}

const PickupPointSelectSingle = ({
  className,
  headline,
  isSelected = false,
  onClick,
  singleOption,
}: PickupPointSelectSingleProps) => {
  const currencyFormatter = useCurrencyFormatter();

  return (
    <Link
      className={classNames(styles.component, className, {
        [styles.isSelected]: isSelected,
      })}
      onClick={onClick}
    >
      <div className={styles.selectIcon}>
        {isSelected && <Icon name="CheckMark" size={20} />}
      </div>

      <div className={styles.content}>
        {headline && (
          <div className={styles.headline}>
            <Typography tag="h3" tagStyle="bodyMediumBold">
              {headline}
            </Typography>
          </div>
        )}

        {singleOption.name && (
          <div className={styles.name}>
            <Typography tagStyle="bodySmall">{singleOption.name}</Typography>
          </div>
        )}

        {singleOption.price > 0 && (
          <div className={styles.price}>
            <Typography tagStyle="bodySmall">
              {currencyFormatter(singleOption.price)}
            </Typography>
          </div>
        )}
      </div>
    </Link>
  );
};

PickupPointSelectSingle.displayName = 'PickupPointSelectSingle';

export default PickupPointSelectSingle;
